/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DerivativesGroupType {
    ALL = 'All',
    GAINERS = 'Gainers',
    LOSERS = 'Losers',
    TWENTY_FOUR_HVOL = 'TwentyFourHVol',
    FAVORITES = 'Favorites',
    USDT_MARGINED = 'UsdtMargined',
    USDC_MARGINED = 'UsdcMargined',
    CRYPTO_MARGINED = 'CryptoMargined',
}
